import {Suspense} from 'react';
import {Outlet} from 'react-router-dom';
import {LayoutProvider} from './common/components/layout/LayoutProvider';
import {MasterInit} from './common/components/layout/MasterInit';
import {SplashScreen} from './common/components/layout/SplashScreen';
import {AuthInit} from './modules/auth';

export default function App() {
	return (
		<Suspense fallback={<SplashScreen />}>
			<LayoutProvider>
				<AuthInit>
					<MasterInit />
					<Outlet />
				</AuthInit>
			</LayoutProvider>
		</Suspense>
	);
}
